/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Word_Quota_UsedInputs */

const en_why_listening_word_quota_used = /** @type {(inputs: Why_Listening_Word_Quota_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word quota almost used`)
};

const es_why_listening_word_quota_used = /** @type {(inputs: Why_Listening_Word_Quota_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límite de palabras casi agotado`)
};

/**
* | output |
* | --- |
* | "Word quota almost used" |
*
* @param {Why_Listening_Word_Quota_UsedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_word_quota_used = /** @type {((inputs?: Why_Listening_Word_Quota_UsedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Word_Quota_UsedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_word_quota_used(inputs)
	return en_why_listening_word_quota_used(inputs)
});